export default __webpack_public_path__ + "static/media/photo--sm--wheel-13.29b0fd4e.jpg";